// Logs.jsx
import React from "react";
import PageLayout from '../../Components/PageLayout';

function Logs() {
    return (
        <PageLayout title="Logs" subtitle="Logs overview">
            <div className="container flex col box-container">
                {/* <div className="box">Logs</div> */}
            </div>
        </PageLayout>   
    );
}

export default Logs;
